import React, { useContext, useState, useEffect } from "react";
import { HashRouter, Route, Routes, Navigate, useLocation } from "react-router-dom";
import Sidebar from "./layout/Sidebar";
import Topbar from "./layout/Topbar";
import Reports from "./Reports/Reports";
import UserManagement from "./usermanagement/UserManagement";
import AddUser from "./usermanagement/AddUser";
import RemoveUser from "./usermanagement/RemoveUser";
import DataSecurity from "./datasecurity/DataSecurity";
import ActivityLogs from "./activitylogs/ActivityLogs";
import { AppContext } from "./context/AppContext";
import Loader from "./widgets/Loader";
import Toast from "./widgets/Toast";
import axiosInstance from "./utils/AxiosInstance";
import { useMsal } from "@azure/msal-react";
import { useMediaQuery } from '@mui/material';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { roles } = useContext(AppContext);
  const userRoles = roles?.role_name || [];

  if (!userRoles.some(role => allowedRoles.includes(role))) {
    return <Navigate to="/" replace />;
  }
  return children;
};

const App = () => {
  //  const location = useLocation(); 
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const { loader, toast, roles, setRoles,setIsDropdownOpen } = useContext(AppContext);
  const [isRoleLoaded, setIsRoleLoaded] = useState(false);
  const isSmallScreen = useMediaQuery('(max-width:768px)');
  // useEffect(() => {
  //   if (isSmallScreen) {
  //     setIsSidebarOpen(false); // ✅ Close sidebar when navigating on small screens
  //   }
  // }, [location, isSmallScreen]);

  const { instance } = useMsal();
  const account = instance.getActiveAccount();
  const normalizedAccountEmail = account?.username?.trim().toLowerCase();
  useEffect(() => {
    if (isSmallScreen) {
      setIsSidebarOpen(false); // Close sidebar on route change if on a small screen
    }
  }, [location]);
  useEffect(() => {
    if (isSmallScreen) {
      setIsSidebarOpen(false)
    } else {
      setIsSidebarOpen(true)
    }
  }, [isSmallScreen]);

  const fetchUser = async (email) => {
    try {
      const response = await axiosInstance.post("/getspecificrole", { email });
      if (response.status === 200) {
        setRoles(response.data || { role_name: [] });
      }
    } catch (error) {
      console.error("Error roles:", error);
      setRoles({ role_name: [] });
    }
  };

  useEffect(() => {
    if (roles?.role_name) {
      setIsRoleLoaded(true);
    }
  }, [roles]);

  useEffect(() => {
    if (normalizedAccountEmail) {
      fetchUser(normalizedAccountEmail);
    }
  }, [normalizedAccountEmail]);

  if (!isRoleLoaded) {
    return <Loader />; // Prevents redirection before roles are loaded
  }

  const getRedirectPath = () => {
    const userRoles = roles?.role_name || [];
    if (userRoles.includes("Admin")) return "/user-management";
    if (userRoles.includes("Editor")) return "/reports";
    if (userRoles.includes("Viewer")) return "/reports";
    return "/reports"; // Default for unauthorized users
  };
  // const handleSidebar=()=>{
  //   if(isSmallScreen && isSidebarOpen){
  //     setIsSidebarOpen(false)
  //   }
  // }
    const toggleDropdown = () => {
    setIsDropdownOpen(false)
  };
  return (
    <HashRouter>
      <div className="flex relative  h-screen " >
        {/* Sidebar with Role-Based Access */}
        {isSidebarOpen && isSmallScreen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-60 z-20"
            onClick={() => setIsSidebarOpen(false)}
          ></div>
        )}
        {/* {isSidebarOpen && ( */}
          <div className="bg-[#F8FAFC] transition-transform duration-300  z-50" onClick={toggleDropdown} >
            <Sidebar
              isSidebarOpen={isSidebarOpen}
              toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
            />

          </div>
        {/* )} */}

        {/* Main Content */}
        <div  className={`flex flex-col w-full static ${isSmallScreen && isSidebarOpen && "fixed inset-0"} `}>

          <Topbar  isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />

          {loader && <Loader />}
          {toast && <Toast message={toast.message} type={toast.type} show={toast.show} />}

          <div className="flex-1 overflow-y-auto p-4 " onClick={toggleDropdown}>
            <Routes>
              {/* Role-Based Default Redirection */}
              <Route path="/" element={<Navigate to={getRedirectPath()} replace />} />

              {/* Protected Routes */}
              <Route
                path="/user-management"
                element={
                  <ProtectedRoute allowedRoles={["Admin"]}>
                    <UserManagement />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/user-management/add-user"
                element={
                  <ProtectedRoute allowedRoles={["Admin"]}>
                    <AddUser />
                  </ProtectedRoute>
                }
              />
               <Route
                path="/user-management/remove-user"
                element={
                  <ProtectedRoute allowedRoles={["Admin"]}>
                    <RemoveUser />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/data-security"
                element={
                  <ProtectedRoute allowedRoles={["Admin", "Editor"]}>
                    <DataSecurity />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/activity-logs"
                element={
                  <ProtectedRoute allowedRoles={["Admin"]}>
                    <ActivityLogs />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/reports"
                element={
                  <ProtectedRoute allowedRoles={["Admin", "Editor", "Viewer"]}>
                    <Reports />
                  </ProtectedRoute>
                }
              />

              {/* Default Route for Undefined Paths */}
              <Route path="*" element={<Navigate to={getRedirectPath()} replace />} />
            </Routes>
          </div>
        </div>
        <div className="absolute bottom-1 right-4 md:text-[14px] text-[10px] text-gray-400">
          © {new Date().getFullYear()} ABRAMS
        </div>
      </div>
    </HashRouter>
  );
};

export default App;

 